import { Injectable, NgZone } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Bringt alle HTTP-Responses zurück in Angulars NgZone.
 *
 * Problem: MSAL holt Access-Tokens über Browser-APIs (IndexedDB, crypto.subtle)
 * die außerhalb von zone.js laufen. Dadurch kommen HTTP-Responses außerhalb
 * der Zone an – Change Detection läuft nicht, Daten erscheinen erst beim nächsten
 * User-Event (Klick, Hover).
 *
 * Lösung: Jedes next/error/complete-Event explizit in ngZone.run() wrappen.
 * Muss als ERSTER Interceptor registriert sein, damit er die Response als
 * letzter verarbeitet (Interceptoren verarbeiten Responses in umgekehrter
 * Reihenfolge zur Registrierung).
 */
@Injectable()
export class NgZoneInterceptor implements HttpInterceptor {
  constructor(private ngZone: NgZone) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return new Observable(observer => {
      const sub = next.handle(req).subscribe({
        next:     value => this.ngZone.run(() => observer.next(value)),
        error:    err   => this.ngZone.run(() => observer.error(err)),
        complete: ()    => this.ngZone.run(() => observer.complete())
      });
      return () => sub.unsubscribe();
    });
  }
}
